// 菜单 顶栏
export default [
  // { path: '/index', title: '首页', icon: 'home' },
  // {
  //   title: '页面',
  //   icon: 'folder-o',
  //   children: [
  //     { path: '/page1', title: '页面 1' },
  //     { path: '/page2', title: '页面 2' },
  //     { path: '/page3', title: '页面 3' }
  //   ]
  // }

  // {
  //   title: '常用功能',
  //   icon: 'folder-o',
  //   children: [
  //     { path: '/userJiaofei', title: '电表缴费' },
  //     { path: '/dianbiaochaxun', title: '电表查询' },
  //     { path: '/tongduankongzhi', title: '通断控制' }
  //   ]
  // },
]
